import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { formatImageName } from "../utils/functions";

const CategoryIcon = ({ category }) => {
  return (
    <div className="feature-item text-center">
      <div className="feature-item__thumb bg-white rounded-circle">
        <Link to="/products" className="w-100 h-100 flex-center">
          <img src={formatImageName(category.icon)} alt={category.name} />
        </Link>
      </div>
      <div className="feature-item__content mt-16">
        <h6 className="text-md-lg text-xs mb-8">
          <Link to="/products" className="text-inherit">
            {category?.name?.length > 15 ? `${category?.name?.slice(0, 15)}...` : category?.name}
          </Link>
        </h6>
      </div>
    </div>
  );
};

const FeatureOne = ({ categories }) => {
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 8,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1699,
        settings: {
          slidesToShow: 8,
        },
      },
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 8,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4.5,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 359,
        settings: {
          slidesToShow: 3.5,
        },
      },
    ],
  };
  return (
    <div className="feature" id="featureSection">
      <div className="container ">
        <div className="position-relative arrow-center">
          <div className="flex-align">
            <button
              type="button"
              id="feature-item-wrapper-prev"
              className="slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
            >
              <i className="ph ph-caret-left" />
            </button>
            <button
              type="button"
              id="feature-item-wrapper-next"
              className="slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
            >
              <i className="ph ph-caret-right" />
            </button>
          </div>
          <div className="feature-item-wrapper">
            <Slider {...settings}>
              {categories.map((category) => (
                <CategoryIcon category={category} key={category._id} />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureOne;
